import { Button, Link } from '@mui/material';
import React from 'react';
import { Icon } from '../../blocks/icons';
import styles from './BackButton.module.scss';
import classNames from 'classnames';

export type BackButtonProps = { className?: string } & (
	| {
		href: string;
		text: string;
	  }
	| {
		onClick: () => void;
		text: string;
	  }
);

export const couldRenderBackButton = ( props: any ): props is BackButtonProps =>
	( typeof props?.href === 'string' || typeof props?.onClick !== 'undefined' ) &&
	typeof props.text === 'string';

export const BackButton: React.FC<BackButtonProps> = ( props ) =>
	'onClick' in props ? (
		<Button
			onClick={ props.onClick }
			className={ classNames( styles.button, props.className ) }
			startIcon={ <Icon type='chevron-left' /> }
			data-cy='paper-back-button'
		>
			{ props.text }
		</Button>
	) : (
		<Link
			href={ props.href }
			className={ classNames( styles.link, props.className ) }
			data-cy='paper-back-button'
		>
			<Icon type='chevron-left' />
			{ props.text }
		</Link>
	);
